// extracted by mini-css-extract-plugin
module.exports = {"title":"selection_title___Vezk","products":"selection_products__YsbX_"};